import { RootState } from 'modules';

export const selectVehicle = {
  meta: (state: RootState) => state.vehicle.meta,
  filter: (state: RootState) => state.vehicle.filter,
  list: (state: RootState) => state.vehicle.list,
  item: (state: RootState) => state.vehicle.item,
};
